import { Chip, ChipTone } from "./Chip";

/** The verdict vocabulary is the collector's and is not enumerated here —
 *  unknown verdicts render neutrally rather than being dropped (§5.6). */
function verdictTone(verdict: string): ChipTone {
  if (verdict === "TAG_SENT_REAL_VALUE") return "green";
  if (verdict === "VALUE_NEVER_PRESENT") return "orange";
  return "neutral";
}

export function VerdictCounters({
  counts,
}: {
  counts: Array<{ verdict: string; count: number }>;
}) {
  if (counts.length === 0) {
    return <span className="text-xs text-gray-400">no captures</span>;
  }
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {counts.map(({ verdict, count }) => (
        <Chip key={verdict} tone={verdictTone(verdict)}>
          {verdict} {count}
        </Chip>
      ))}
    </div>
  );
}
